<template>
  <router-view />
</template>

<style>
#app {
  background: cornsilk;
}
</style>
